/* ============================================================================
   gs-addons-bundle.js — grow-some
   Path: assets/gs-addons-bundle.js

   Coordinator JS for product add-on blocks.
   ============================================================================ */

(function(){
  'use strict';

  // ── Shared constants (same for every instance) ─────────────────────
  var CDN = 'https://cdn.shopify.com/s/files/1/0568/2688/8235/files/';
  var MATS = [
    {id:'brokoli', name:'Броколі',         img: CDN+'grow-some-seedpad-broccoli.webp?v=1777217511'},
    {id:'kapusta', name:'Капуста червона', img: CDN+'grow-some-seedpad-red-cabbage.webp?v=1777217511'},
    {id:'morkva',  name:'Морква',          img: CDN+'grow-some-seedpad-carrot.webp?v=1777217511'},
    {id:'shchek',  name:'Щекавиця (мікс)', img: CDN+'grow-some-seedpad-shekavysya.webp?v=1777218120'},
    {id:'lyuts',   name:'Люцерна',         img: CDN+'grow-some-seedpad-alfalfa.webp?v=1777217510'},
    {id:'sonyakh', name:'Сонях',           img: CDN+'grow-some-seedpad-sunflower.webp?v=1777217511'},
    {id:'redys',   name:'Редис',           img: CDN+'grow-some-seedpad-radish.webp?v=1777217511'},
    {id:'gorox',   name:'Горох вусатий',   img: CDN+'grow-some-seedpad-pea.webp?v=1777217511'},
    {id:'girch',   name:'Гірчиця',         img: CDN+'grow-some-seedpad-mustard.webp?v=1777217511'},
    {id:'kony',    name:'Конюшина',        img: CDN+'grow-some-seedpad-clover.webp?v=1777218120'},
    {id:'koty',    name:'Трава котикам',   img: CDN+'grow-some-seedpad-catgrass.webp?v=1777217511'},
    {id:'gorox2',  name:'Горох дикий',     img: CDN+'grow-some-seedpad-wild-pea.webp?v=1777217511'}
  ];

  // ─────────────────────────────────────────────────────────────────────
  // Per-instance coordinator
  // ─────────────────────────────────────────────────────────────────────
  function initCoordinator(config){
    var SECTION_ID = config.sectionId;
    var PRODUCT_VARIANT_ID = config.productVariantId;
    var PRODUCT_PRICE_CENTS = config.productPriceCents;
    var MAT_LIMIT = config.matLimit || 0;
    var SHOP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var STORAGE_KEY = 'gs_state_' + config.productId;

    // ── Pot catalog: built from DOM (admin-driven) ──────────────────
    // Read once at init. Each .gs-pot-card carries data-vid, data-price-cents,
    // data-name, data-oos, data-preorder-url. State key for each pot is the
    // pot's stable handle (data-pot="std"|"cer"|"dbl"), not the variant id —
    // so prices/names can change in admin without breaking saved cart state.
    function buildPotCatalog(){
      var catalog = {};
      var block = document.querySelector('.gs-pots-block[data-section-id="' + SECTION_ID + '"]');
      if (!block) return catalog;
      block.querySelectorAll('.gs-pot-card').forEach(function(card){
        var k = card.dataset.pot;
        if (!k) return;
        catalog[k] = {
          vid: parseInt(card.dataset.vid, 10) || 0,
          price_cents: parseInt(card.dataset.priceCents, 10) || 0,
          name: card.dataset.name || k,
          oos: card.dataset.oos === 'true'
        };
      });
      return catalog;
    }
    var POTS = buildPotCatalog();
    var POT_KEYS = Object.keys(POTS);

    // ── State ───────────────────────────────────────────────────────
    var state = {
      productPrice: PRODUCT_PRICE_CENTS,
      productVariantId: PRODUCT_VARIANT_ID,
      mainQty: 1,
      mats: {},
      pots: {},
      packaging: null,
      spray: null
    };
    MATS.forEach(function(m){ state.mats[m.id] = 0; });
    POT_KEYS.forEach(function(k){ state.pots[k] = 0; });

    // ── Helpers ────────────────────────────────────────────────────
    function fmtGrn(cents){
      var v = (cents / 100);
      var rounded = Math.round(v * 100) / 100;
      var str;
      if (rounded === Math.floor(rounded)){
        str = String(Math.floor(rounded));
      } else {
        str = rounded.toFixed(2).replace(/\.?0+$/, '');
      }
      return str + ' грн';
    }
    function decKyl(n){
      var a = Math.abs(n) % 100, r = a % 10;
      if (a >= 11 && a <= 19) return 'килимків';
      if (r === 1) return 'килимок';
      if (r >= 2 && r <= 4) return 'килимки';
      return 'килимків';
    }
    function matTotal(){
      return Object.keys(state.mats).reduce(function(s,k){ return s + (state.mats[k]||0); }, 0);
    }
    function bundleCents(){
      var s = state.productPrice || 0;
      POT_KEYS.forEach(function(k){
        var qty = state.pots[k] || 0;
        if (qty > 0 && POTS[k]) s += POTS[k].price_cents * qty;
      });
      if (state.packaging) s += (state.packaging.price_cents || 0);
      if (state.spray)     s += (state.spray.price_cents || 0);
      return s;
    }
    function totalCents(){ return bundleCents() * state.mainQty; }

    function saveState(){
      try{
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
          mats: state.mats,
          pots: state.pots,
          packaging: state.packaging,
          spray: state.spray,
          savedAt: Date.now()
        }));
      }catch(e){}
    }
    function loadState(){
      try{
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var d = JSON.parse(raw);
        if (Date.now() - d.savedAt > 3600000){ localStorage.removeItem(STORAGE_KEY); return; }
        if (d.mats) Object.keys(d.mats).forEach(function(k){ if (k in state.mats) state.mats[k] = d.mats[k]; });
        if (d.pots) Object.keys(d.pots).forEach(function(k){ if (k in state.pots) state.pots[k] = d.pots[k]; });
        state.packaging = d.packaging || null;
        state.spray     = d.spray     || null;
        if (MAT_LIMIT > 0 && matTotal() > MAT_LIMIT){
          Object.keys(state.mats).forEach(function(k){ state.mats[k] = 0; });
        }
      }catch(e){}
    }

    function toast(msg, isErr){
      var el = document.getElementById('gs-toast-' + SECTION_ID);
      if (!el) return;
      el.querySelector('.gs-toast-msg').textContent = msg;
      el.classList.toggle('success', !isErr);
      el.classList.add('show');
      if (!isErr) setTimeout(function(){ el.classList.remove('show'); }, 4000);
    }

    // ── Mat selector ───────────────────────────────────────────────
    function initMatSelector(){
      var container = document.getElementById('gs-mat-grid-' + SECTION_ID);
      if (!container) return;

      var minusSVG = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="0" y="6" width="14" height="2" fill="currentColor"/></svg>';
      var plusSVG  = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="0" y="6" width="14" height="2" fill="currentColor"/><rect x="6" y="0" width="2" height="14" fill="currentColor"/></svg>';

      container.innerHTML = MATS.map(function(m){
        return ''
          + '<div class="gs-mat-card" data-mat-id="' + m.id + '" data-mat-name="' + m.name + '">'
          +   '<div class="gs-mat-img-wrap">'
          +     '<img src="' + m.img + '" alt="' + m.name + '" loading="lazy">'
          +   '</div>'
          +   '<div class="gs-mat-body">'
          +     '<p class="gs-mat-name">' + m.name + '</p>'
          +   '</div>'
          +   '<div class="gs-mat-cnt-wrap">'
          +     '<div class="gs-mat-cnt">'
          +       '<button class="gs-mc-btn" type="button" data-role="minus" disabled aria-label="−">' + minusSVG + '</button>'
          +       '<input class="gs-mc-input" type="number" value="0" min="0" data-role="input" inputmode="numeric">'
          +       '<button class="gs-mc-btn" type="button" data-role="plus" aria-label="+">' + plusSVG + '</button>'
          +     '</div>'
          +   '</div>'
          + '</div>';
      }).join('');

      container.querySelectorAll('.gs-mat-card').forEach(function(card){
        var id = card.dataset.matId;
        card.querySelector('[data-role="minus"]').addEventListener('click', function(){ matDelta(id, -1); });
        card.querySelector('[data-role="plus"]').addEventListener('click',  function(){ matDelta(id,  1); });
        var inp = card.querySelector('[data-role="input"]');
        inp.addEventListener('focus', function(){ this.select(); });
        inp.addEventListener('input', function(){ matInput(id, this.value, false); });
        inp.addEventListener('blur',  function(){ matInput(id, this.value, true); });
      });
    }

    function matDelta(id, delta){
      var cur = state.mats[id] || 0;
      var nv = cur + delta;
      if (nv < 0) return;
      if (delta > 0 && MAT_LIMIT > 0 && matTotal() >= MAT_LIMIT) return;
      state.mats[id] = nv;
      renderAll();
    }
    function matInput(id, val, isBlur){
      var nv = parseInt(val, 10);
      if (isNaN(nv) || nv < 0) nv = 0;
      if (MAT_LIMIT > 0){
        var others = 0;
        Object.keys(state.mats).forEach(function(k){ if (k !== id) others += state.mats[k] || 0; });
        var max = Math.max(MAT_LIMIT - others, 0);
        if (nv > max) nv = max;
      }
      state.mats[id] = nv;
      if (isBlur){
        var card = document.querySelector('.gs-mat-card[data-mat-id="' + id + '"]');
        if (card){
          var inp = card.querySelector('[data-role="input"]');
          if (inp && parseInt(inp.value, 10) !== nv) inp.value = nv;
        }
      }
      renderAll();
    }
    function renderMatSelector(){
      var container = document.getElementById('gs-mat-grid-' + SECTION_ID);
      if (!container) return;

      var tot = matTotal();
      var atLimit = MAT_LIMIT > 0 && tot >= MAT_LIMIT;

      var counterEl = document.querySelector('.gs-mat-selector-block[data-section-id="' + SECTION_ID + '"] [data-role="mat-counter"]');
      if (counterEl){
        if (MAT_LIMIT > 0){
          counterEl.textContent = tot + '/' + MAT_LIMIT + ' обрано';
          counterEl.style.color = (tot === MAT_LIMIT) ? '#2D5040' : '';
        } else {
          counterEl.textContent = '';
        }
      }

      container.querySelectorAll('.gs-mat-card').forEach(function(card){
        var id = card.dataset.matId;
        var q  = state.mats[id] || 0;
        card.classList.toggle('sel', q > 0);
        var minus = card.querySelector('[data-role="minus"]');
        var plus  = card.querySelector('[data-role="plus"]');
        var input = card.querySelector('[data-role="input"]');
        if (minus) minus.disabled = (q === 0);
        if (plus)  plus.disabled  = atLimit;
        if (input && document.activeElement !== input) input.value = q;
      });

      var errEl = document.querySelector('.gs-mat-selector-block[data-section-id="' + SECTION_ID + '"] .gs-mat-error');
      if (errEl && MAT_LIMIT > 0 && tot === MAT_LIMIT) errEl.classList.remove('show');
    }

    // ── Pots ──────────────────────────────────────────────────────
    function initPots(){
      var block = document.querySelector('.gs-pots-block[data-section-id="' + SECTION_ID + '"]');
      if (!block) return;

      POT_KEYS.forEach(function(k){
        var card = block.querySelector('.gs-pot-card[data-pot="' + k + '"]');
        if (!card) return;

        if (POTS[k].oos){
          var url = (card.dataset.preorderUrl || '').trim();
          var cntWrap = card.querySelector('.gs-pot-cnt-wrap');
          if (cntWrap){
            var node;
            if (url){
              node = document.createElement('a');
              node.href = url; node.className = 'gs-pot-preorder'; node.target = '_self';
            } else {
              node = document.createElement('div'); node.className = 'gs-pot-preorder gs-static';
            }
            node.textContent = 'Передзамовлення →';
            node.addEventListener('click', function(e){ e.stopPropagation(); });
            cntWrap.parentNode.replaceChild(node, cntWrap);
          }
          var imgWrap = card.querySelector('.gs-pot-img');
          if (imgWrap && !imgWrap.querySelector('.gs-pot-oos-badge')){
            var b = document.createElement('span');
            b.className = 'gs-pot-oos-badge';
            b.textContent = '⚠️ Нема в наявності';
            imgWrap.appendChild(b);
          }
          return;
        }

        card.addEventListener('click', function(e){
          if (e.target.closest('.gs-pot-cnt-wrap')) return;
          if (state.pots[k] === 0) potDelta(k, 1);
        });
        card.querySelector('[data-role="pot-minus"]').addEventListener('click', function(e){
          e.stopPropagation(); potDelta(k, -1);
        });
        card.querySelector('[data-role="pot-plus"]').addEventListener('click', function(e){
          e.stopPropagation(); potDelta(k, 1);
        });
      });
    }
    function potDelta(k, d){
      var nv = state.pots[k] + d;
      if (nv < 0 || nv > 2) return;
      state.pots[k] = nv;
      renderAll();
    }
    function renderPots(){
      var block = document.querySelector('.gs-pots-block[data-section-id="' + SECTION_ID + '"]');
      if (!block) return;
      POT_KEYS.forEach(function(k){
        var card = block.querySelector('.gs-pot-card[data-pot="' + k + '"]');
        if (!card || POTS[k].oos) return;
        var q = state.pots[k];
        card.classList.toggle('sel', q > 0);
        var badge = card.querySelector('.gs-pot-badge');
        if (badge) badge.textContent = q || '1';
        var val   = card.querySelector('[data-role="pot-input"]');
        var minus = card.querySelector('[data-role="pot-minus"]');
        if (val)   val.value = q;
        if (minus) minus.disabled = (q === 0);
      });
    }

    // ── Dropdowns (packaging, spray) ─────────────────────────────
    function initDropdown(block, onSelect){
      if (!block) return;
      var dd      = block.querySelector('.gs-dd');
      var current = block.querySelector('.gs-dd-current');
      var menu    = block.querySelector('.gs-dd-menu');
      if (!dd || !menu || !current) return;

      dd.setAttribute('aria-expanded', 'false');

      dd.addEventListener('click', function(e){
        if (e.target.closest('.gs-dd-menu')) return;
        var open = dd.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.gs-dd[aria-expanded="true"]').forEach(function(d){
          if (d !== dd) d.setAttribute('aria-expanded', 'false');
        });
        dd.setAttribute('aria-expanded', !open);
      });

      menu.querySelectorAll('.gs-dd-opt').forEach(function(opt){
        opt.addEventListener('click', function(e){
          e.stopPropagation();
          menu.querySelectorAll('.gs-dd-opt').forEach(function(o){ o.classList.remove('sel'); });
          opt.classList.add('sel');
          var label = opt.querySelector('.gs-dd-opt-text');
          current.textContent = label ? label.textContent.trim() : opt.textContent.trim();
          current.classList.toggle('sel', opt.dataset.value !== '');
          dd.setAttribute('aria-expanded', 'false');
          onSelect(opt);
        });
      });
    }

    function initPackaging(){
      var block = document.querySelector('.gs-packaging-block[data-section-id="' + SECTION_ID + '"]');
      if (!block) return;
      initDropdown(block, function(opt){
        var v = opt.dataset.value;
        if (!v){
          state.packaging = null;
        } else {
          state.packaging = {
            vid: parseInt(opt.dataset.vid, 10),
            price_cents: parseInt(opt.dataset.priceCents, 10) || 0,
            name: opt.dataset.name || ''
          };
        }
        renderAll();
      });
    }

    function initSpray(){
      var block = document.querySelector('.gs-spray-block[data-section-id="' + SECTION_ID + '"]');
      if (!block) return;
      initDropdown(block, function(opt){
        var v = opt.dataset.value;
        if (v === '1'){
          state.spray = {
            vid: parseInt(opt.dataset.vid, 10),
            price_cents: parseInt(opt.dataset.priceCents, 10) || 0,
            name: opt.dataset.name || 'Пляшечка-розпилювач'
          };
        } else {
          state.spray = null;
        }
        renderAll();
      });
    }

    // ── CTA / qty / price wiring ─────────────────────────────────
    function initQuantityListener(){
      var qInput = document.getElementById('Quantity-' + SECTION_ID);
      if (!qInput) return;
      var read = function(){
        var v = parseInt(qInput.value, 10);
        state.mainQty = (isNaN(v) || v < 1) ? 1 : v;
        renderAll();
      };
      qInput.addEventListener('change', read);
      qInput.addEventListener('input',  read);
      read();
    }

    function findBuyButton(){
      return document.querySelector('#product-form-' + SECTION_ID + ' [type="submit"], #product-form-' + SECTION_ID + ' [name="add"]');
    }

    function renderBuyButton(){
      var btn = findBuyButton();
      if (!btn) return;
      if (btn.dataset.gsBusy === '1') return;
      btn.classList.add('gs-cta-with-price');
      btn.style.setProperty('--gs-price', '"' + fmtGrn(totalCents()) + '"');
    }

    function initVariantListener(){
      var host = document.getElementById('MainProduct-' + SECTION_ID);
      if (!host) return;

      host.addEventListener('variant:change', function(e){
        var v = e && e.detail && e.detail.variant;
        if (v){
          state.productPrice = v.price;
          state.productVariantId = v.id;
          renderAll();
        }
      });

      var idInput = host.querySelector('input[name="id"]');
      if (idInput){
        new MutationObserver(function(){
          var newId = parseInt(idInput.value, 10);
          if (newId && newId !== state.productVariantId){
            state.productVariantId = newId;
            var script = host.querySelector('[type="application/json"][data-product-json]');
            if (script){
              try{
                var data = JSON.parse(script.textContent);
                var found = (data.variants || []).find(function(v){ return v.id === newId; });
                if (found) state.productPrice = found.price;
              }catch(e){}
            }
            renderAll();
          }
        }).observe(idInput, {attributes:true, attributeFilter:['value']});
      }
    }

    // ── Form intercept ──────────────────────────────────────────
    // Чи треба нам перехоплювати submit? Так — лише коли є що додавати окрім
    // головного товару (килимки як properties / pot / packaging / spray).
    // Інакше пропускаємо event далі, нехай Dawn робить нативно — так само як
    // на продуктах без GS-блоків (форма + продукт-форм custom element).
    function hasBundleAddons(){
      if (matTotal() > 0) return true;                          // mat properties on mainItem
      for (var k in state.pots){ if (state.pots[k] > 0) return true; }
      if (state.packaging) return true;
      if (state.spray) return true;
      return false;
    }

    function initFormIntercept(){
      var form = document.getElementById('product-form-' + SECTION_ID);
      if (!form) return;

      form.addEventListener('submit', function(e){
        var btn = findBuyButton();

        // ── Mat validation gate ─────────────────────────────────────
        // Якщо продукт має мат-блок (matLimit > 0 і блок є в секції),
        // перевіряємо що користувач обрав РІВНО matLimit килимків.
        var matContainer = document.getElementById('gs-mat-grid-' + SECTION_ID);
        if (MAT_LIMIT > 0 && matContainer){
          var tot = matTotal();
          if (tot !== MAT_LIMIT){
            e.preventDefault();
            e.stopImmediatePropagation();
            
            // Знімаємо стан завантаження Dawn
            if (btn) {
               btn.classList.remove('loading', 'gs-loading');
               btn.removeAttribute('aria-disabled');
               var spinner = btn.querySelector('.loading-overlay__spinner');
               if (spinner) spinner.classList.add('hidden');
            }

            var errEl = document.querySelector('.gs-mat-selector-block[data-section-id="' + SECTION_ID + '"] .gs-mat-error');
            if (errEl){
              errEl.textContent = 'Оберіть рівно ' + MAT_LIMIT + ' ' + decKyl(MAT_LIMIT) + '. Зараз обрано ' + tot + '.';
              errEl.classList.add('show');
              errEl.scrollIntoView({behavior:'smooth', block:'center'});
            } else {
              toast('Оберіть ' + MAT_LIMIT + ' ' + decKyl(MAT_LIMIT), true);
            }
            return false;
          }
        }

        // ── No-addons fast-path ─────────────────────────────────────
        // Якщо нема ні килимків, ні апселл-айтемів — нема сенсу робити
        // власний bulk cart/add. Пропускаємо event далі, Dawn зробить свій
        // нативний submit (FormData → /cart/add → cart-drawer renderContents).
        // Це шлях, який Dawn гарантовано вміє обробляти (на відміну від
        // нашого items-array запиту, який повертає інакший shape parsedState).
        if (!hasBundleAddons()) {
          return;  // не preventDefault — пропускаємо в bubble phase, Dawn перехопить
        }

        // ── Has bundle addons: intercept ────────────────────────────
        e.preventDefault();
        e.stopImmediatePropagation();
        submitBundle();
        return false;
      }, true);
    }

    function submitBundle(){
      var btn = findBuyButton();
      var origHtml = '';
      if (btn){
        btn.dataset.gsBusy = '1';
        origHtml = btn.innerHTML;
        btn.disabled = true;
        btn.classList.add('gs-loading');
        if(!btn.querySelector('.gs-spinner')) {
           btn.innerHTML = '<span class="gs-spinner"></span><span>Додаємо...</span>';
        }
      }

      // Збираємо килимки (йдуть як properties до основного товару)
      var props = {};
      Object.keys(state.mats).forEach(function(id){
        var q = state.mats[id] || 0;
        if (q > 0){
          var meta = MATS.find(function(m){ return m.id === id; });
          props['Килимок ' + (meta ? meta.name : id)] = q + ' ' + decKyl(q);
        }
      });

      var qty = state.mainQty;
      var mainItem = { id: state.productVariantId, quantity: qty };
      if (Object.keys(props).length > 0) mainItem.properties = props;

      // Збираємо всі товари в один масив
      var allItems = [mainItem];
      POT_KEYS.forEach(function(k){
        var pq = state.pots[k] || 0;
        if (pq > 0 && POTS[k] && POTS[k].vid){
          allItems.push({ id: POTS[k].vid, quantity: pq * qty });
        }
      });
      if (state.packaging) allItems.push({ id: state.packaging.vid, quantity: qty });
      if (state.spray) allItems.push({ id: state.spray.vid, quantity: qty });

      // Знаходимо компонент кошика Dawn та секції, які треба оновити
      var target = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sectionsToRender = [];
      if (target && typeof target.getSectionsToRender === 'function') {
          sectionsToRender = target.getSectionsToRender().map(function(s) { return s.id; });
      } else {
          sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];
      }

      function restoreButton(){
        if (!btn) return;
        btn.dataset.gsBusy = '0';
        btn.disabled = false;
        btn.classList.remove('loading', 'gs-loading');
        btn.removeAttribute('aria-disabled');
        btn.innerHTML = origHtml;
        renderBuyButton();
      }

      // Відправляємо один запит на ВСІ товари одразу
      fetch(SHOP_ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: allItems,
          sections: sectionsToRender,
          sections_url: window.location.pathname
        })
      })
      .then(function(r) {
        if (!r.ok) throw new Error('Помилка додавання ' + r.status);
        return r.json();
      })
      .then(function(parsedState) {
        restoreButton();

        // ── Normalize response shape ────────────────────────────────
        // cart/add.js з items-array повертає { items:[...], item_count, sections }.
        // Dawn-овий renderContents (особливо cart-notification) очікує single-line-item
        // shape з parsedState.id / parsedState.key на верхньому рівні (для побудови
        // селекторів). Копіюємо ці поля з першого items-елемента, щоб Dawn не падав.
        if (parsedState && parsedState.items && parsedState.items.length && parsedState.id == null){
          parsedState.id  = parsedState.items[0].id;
          parsedState.key = parsedState.items[0].key;
        }

        // Оновлюємо іконку в хедері (Fallback на випадок якщо renderContents не оновить)
        document.querySelectorAll('.cart-count-bubble').forEach(function(b){
           var sp = b.querySelector('span:not(.visually-hidden)');
           if (sp && parsedState.item_count != null) sp.textContent = parsedState.item_count;
        });

        // Ідеальна інтеграція з Dawn: передаємо отримані секції для рендеру.
        // Dawn-овий cart-notification.getSectionsToRender() читає this.productId
        // для побудови селектора cart-notification-product-${id}. Виставляємо ДО виклику.
        if (target && typeof target.renderContents === 'function') {
           if (parsedState.id != null) target.productId = parsedState.id;
           try {
             target.renderContents(parsedState);
           } catch (renderErr){
             // Бекенд додав товар, але Dawn-render зламався — не кажемо юзеру що
             // не вдалось додати (це неправда). Залишаємо update item_count у bubble
             // і робимо м'який fallback: відкриваємо drawer/notification без render-у.
             console.error('[gs-addons] renderContents failed (item WAS added):', renderErr);
             if (typeof target.open === 'function') target.open();
           }
        } else {
           window.location.href = SHOP_ROOT + 'cart';
        }
      })
      .catch(function(err){
        console.error('[gs-addons] add failed:', err);
        toast('Не вдалось додати: ' + err.message, true);
        restoreButton();
      });
    }

    function renderAll(){
      renderMatSelector();
      renderPots();
      renderBuyButton();
      saveState();
    }

    // ── Start ───────────────────────────────────────────────────
    loadState();
    initMatSelector();
    initPots();
    initPackaging();
    initSpray();
    initQuantityListener();
    initVariantListener();
    initFormIntercept();

    if (state.packaging){
      var pBlock = document.querySelector('.gs-packaging-block[data-section-id="' + SECTION_ID + '"]');
      if (pBlock){
        var opt = pBlock.querySelector('.gs-dd-opt[data-vid="' + state.packaging.vid + '"]');
        if (opt){
          pBlock.querySelectorAll('.gs-dd-opt').forEach(function(o){ o.classList.remove('sel'); });
          opt.classList.add('sel');
          var cur = pBlock.querySelector('.gs-dd-current');
          var lbl = opt.querySelector('.gs-dd-opt-text');
          if (cur && lbl){ cur.textContent = lbl.textContent.trim(); cur.classList.add('sel'); }
        } else {
          state.packaging = null;
        }
      }
    }
    if (state.spray){
      var sBlock = document.querySelector('.gs-spray-block[data-section-id="' + SECTION_ID + '"]');
      if (sBlock){
        var sopt = sBlock.querySelector('.gs-dd-opt[data-value="1"]');
        if (sopt){
          sBlock.querySelectorAll('.gs-dd-opt').forEach(function(o){ o.classList.remove('sel'); });
          sopt.classList.add('sel');
          var scur = sBlock.querySelector('.gs-dd-current');
          var slbl = sopt.querySelector('.gs-dd-opt-text');
          if (scur && slbl){ scur.textContent = slbl.textContent.trim(); scur.classList.add('sel'); }
        }
      }
    }

    renderAll();
  }

  function bootstrap(){
    var configs = document.querySelectorAll('script[type="application/json"][data-gs-config]');
    for (var i = 0; i < configs.length; i++){
      try {
        var config = JSON.parse(configs[i].textContent);
        initCoordinator(config);
      } catch(e){
        console.error('[gs-addons] bad config script:', e);
      }
    }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();